module.exports = __webpack_public_path__ + "img/hourglass.7e14d463.gif";